import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

import {viewPlan} from '../plan-list/core/_requests'
import {EditPlan} from '../plan-form/EditPlan'

export const EditPlanWrapper = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>(null)
  useEffect(() => {
    viewPlan(id).then((res) => {
      setData(res.Data)
    })
  }, [id])
  if (data) {
    return <EditPlan initialValues={data} />
  }
  return null
}
